{
  "name": "@uppy/remote-sources",
  "description": "Uppy plugin that includes all remote sources that Uppy+Companion offer, like Instagram, Google Drive, Dropox, Box, Unsplash, Url etc",
  "version": "3.1.0",
  "license": "MIT",
  "type": "module",
  "sideEffects": false,
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build",
    "test": "vitest run --environment=jsdom --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "instagram",
    "google-drive",
    "facebook",
    "dropbox",
    "onedrive",
    "zoom",
    "unsplash",
    "box",
    "url"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/box": "workspace:^",
    "@uppy/dashboard": "workspace:^",
    "@uppy/dropbox": "workspace:^",
    "@uppy/facebook": "workspace:^",
    "@uppy/google-drive": "workspace:^",
    "@uppy/instagram": "workspace:^",
    "@uppy/onedrive": "workspace:^",
    "@uppy/unsplash": "workspace:^",
    "@uppy/url": "workspace:^",
    "@uppy/zoom": "workspace:^"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "publishConfig": {
    "access": "public"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "jsdom": "^26.1.0",
    "resize-observer-polyfill": "^1.5.1",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  }
}
